/**
 * TikTok Pixel tracking utilities for donation platform
 */

// Extend window object to include TikTok pixel
declare global {
  interface Window {
    ttq: any;
  }
}

export interface TikTokEventData {
  contents: Array<{
    content_id: string;
    content_type: string;
    content_name: string;
    price: number;
    quantity: number;
  }>;
  value: number;
  currency: string;
}

/**
 * Track when a user adds payment information
 */
export const trackAddPaymentInfo = (
  donationAmount: number,
  currency: string,
  programTitle: string,
): void => {
  try {
    if (typeof window !== "undefined" && window.ttq) {
      const eventData: TikTokEventData = {
        contents: [
          {
            content_id: "donation",
            content_type: "product",
            content_name: programTitle,
            price: donationAmount,
            quantity: 1,
          },
        ],
        value: donationAmount,
        currency: currency,
      };

      window.ttq.track("AddPaymentInfo", eventData);
    }
  } catch (error) {
    console.error("[TikTok Pixel] Error tracking AddPaymentInfo:", error);
  }
};

/**
 * Track when a donation is completed successfully
 * Using TikTok's standard "Purchase" event instead of "CompletePayment"
 */
export const trackPurchase = (
  donationId: string | number,
  donationAmount: number,
  currency: string,
  programTitle: string,
): void => {
  try {
    if (typeof window !== "undefined" && window.ttq) {
      const eventData: TikTokEventData = {
        contents: [
          {
            content_id: donationId.toString(),
            content_type: "product",
            content_name: programTitle,
            price: donationAmount,
            quantity: 1,
          },
        ],
        value: donationAmount,
        currency: currency,
      };

      window.ttq.track("Purchase", eventData);
    }
  } catch (error) {
    console.error("[TikTok Pixel] Error tracking Purchase:", error);
  }
};
